module.exports = lodash;